import { combineReducers } from 'redux';

import * as types from '../constants';

const customerNotes = (state = '', action) => {
  switch (action.type) {
    case types.LOAD_CUSTOMER_NOTES:
      return action.payload;
    case types.SET_CUSTOMER_NOTES:
      return action.payload;
    case types.RESET_CUSTOMER_NOTES:
      return '';
    default:
      return state;
  }
};

const promoCode = (state = '', action) => {
  switch (action.type) {
    case types.SET_PROMO_CODE:
      return action.payload.promoCode || '';
    default:
      return state;
  }
};

const promoAmount = (state = 0, action) => {
  switch (action.type) {
    case types.SET_PROMO_CODE:
      return action.payload.promoAmount || 0;
    default:
      return state;
  }
};

export default combineReducers({
  customerNotes,
  promoCode,
  promoAmount,
});
